(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.GoogleTagManager = factory());
})(this, (function () { 'use strict';

    /**
     * Add extra Google Tag Manager handling for Cookie Consent
     */
    class GoogleTagManager {
      /**
       * Hook into cookieConsent to push data to GTM
       *
       * @param {HTMLElement} cookieDialog
       */
      constructor(cookieDialog) {
        this.cookieDialog = cookieDialog;

        if (typeof window.dataLayer === 'undefined') {
          window.dataLayer = [];
        }
      }
      /**
       * Hook into useful events to push their data to GTM
       */


      forwardEvents() {
        this.forwardAnswerEvents();
        this.forwardCategoryEvents();
      }
      /**
       * Hook into the activateCategory event to push the category event to GTM
       * Used to load extra tracking scripts
       *
       * @return {GoogleTagManager}
       */


      forwardCategoryEvents() {
        this.cookieDialog.addEventListener('activateCategory', e => {
          window.dataLayer.push({
            'event': 'cookie-consent-' + e.detail.category
          });
        });
        return this;
      }
      /**
       * Hook into the answer event to push answer data to GTM
       * Used to forward this info to Google Analytics
       *
       * @return {GoogleTagManager}
       */


      forwardAnswerEvents() {
        this.cookieDialog.addEventListener('answer', e => {
          window.dataLayer.push({
            'event': 'cookie-consent-answer',
            'consent': e.detail.consent,
            'categories': e.detail.categories ? e.detail.categories.join(', ') : '/'
          });
        });
        return this;
      }

    }

    return GoogleTagManager;

}));
